import { FAILURE, POST, PUT, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

const BASE_URL =
    "https://gestiondeflota.boltrack.net/apiultimamillav3/api/status-kanban";

const parseStatusKanban = (value) => {
    if (Array.isArray(value)) return value;

    if (typeof value === "string" && value.trim()) {
        try {
            return parseStatusKanban(JSON.parse(value));
        } catch (err) {
            return [];
        }
    }

    if (value && typeof value === "object") {
        const nestedValue =
            value.statusKanban ??
            value.status ??
            value.estados ??
            value.data ??
            null;
        return nestedValue === value ? [] : parseStatusKanban(nestedValue);
    }

    return [];
};

const normalizeStatusResponse = (body) => {
    const record =
        Array.isArray(body) &&
            body.length === 1 &&
            body[0] &&
            typeof body[0] === "object" &&
            body[0].id != null &&
            (body[0].statusKanban != null ||
                body[0].status != null ||
                body[0].estados != null)
            ? body[0]
            : body;

    const isObjectRecord =
        record && !Array.isArray(record) && typeof record === "object";

    return {
        id: isObjectRecord ? record.id ?? null : null,
        idTablero: isObjectRecord ? record.idTablero ?? null : null,
        data: parseStatusKanban(record),
    };
};

export async function guardarStatusKanban(statusKanban, idTablero = null) {
    try {
        const { code, body, message } = await fetch(
            `${BASE_URL}/crear-status-kanban`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify({ statusKanban, idTablero }),
            }
        ).then((res) => res.json());

        if (code === SUCCESS) {
            const normalized = normalizeStatusResponse(body);
            return {
                error: false,
                data: body,
                id: body,
                idTablero: normalized.idTablero,
                message,
            };
        }
        if (code === FAILURE) return { error: true, message };
        return { error: true, message };
    } catch (err) {
        console.log("guardarStatusKanban err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarStatusKanban(id, statusKanban, idTablero = null) {
    try {
        const { code, body, message } = await fetch(
            `${BASE_URL}/actualizar-status-kanban`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify({ id, statusKanban, idTablero }),
            }
        ).then((res) => res.json());

        if (code === SUCCESS) {
            const normalized = normalizeStatusResponse(body);
            return {
                error: false,
                data: body,
                id: normalized.id ?? id,
                idTablero: normalized.idTablero ?? idTablero,
                message,
            };
        }
        if (code === FAILURE) return { error: true, message };
        return { error: true, message };
    } catch (err) {
        console.log("actualizarStatusKanban err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerStatusKanban(obj = {}) {
    try {
        const payload = { idTablero: null, ...obj };
        const { code, body, message } = await fetch(
            `${BASE_URL}/obtener-lista-status-kanban`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(payload),
            }
        ).then((res) => res.json());

        if (code === SUCCESS) {
            const normalized = normalizeStatusResponse(body);
            return {
                error: false,
                id: normalized.id,
                idTablero: normalized.idTablero,
                data: normalized.data,
                message,
            };
        }
        if (code === FAILURE) return { error: true, message, data: [] };
        return { error: true, message, data: [] };
    } catch (err) {
        console.log("obtenerStatusKanban err");
        console.log(err);
        return { error: true, message: err, data: [] };
    }
}